import { EXHIBITION_PATH, PORTFOLIO_PATH, STORE_PATH } from '@/shared/config';

/** 견적문의 바로가기 한 칸 — 영문 머리말·이름·한 줄 설명·목적지. */
export interface QuoteShortcut {
  readonly eyebrow: string;
  readonly title: string;
  readonly description: string;
  readonly to: string;
}

export const QUOTE_SHORTCUTS: readonly QuoteShortcut[] = [
  {
    eyebrow: 'Store',
    title: '상품 보러 가기',
    description: '디자인할 상품을 카테고리별로 둘러보세요.',
    to: STORE_PATH,
  },
  {
    eyebrow: 'Exhibition',
    title: '목적별 기획전',
    description: '행사·선물 등 목적에 맞게 묶은 상품을 살펴보세요.',
    to: EXHIBITION_PATH,
  },
  {
    eyebrow: 'Portfolio',
    title: '제작 사례 보기',
    description: '다른 기업·단체가 만든 굿즈를 참고하세요.',
    to: PORTFOLIO_PATH,
  },
];
